import baseTheme from '../baseTheme';
export var MuiAccordion = {
    root: {
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: baseTheme.palette.grey[300],
        borderLeftWidth: 0,
        borderRightWidth: 0,
        borderTopWidth: 0,
        '&.Mui-expanded': {
            margin: 0,
        },
        // killing the pseudoelement that creates a false border
        '&::before': {
            display: 'none',
        },
    },
};
//# sourceMappingURL=MuiAccordion.js.map